import T from '../i18n/Text';
import { ReactComponent as Tv } from "../../images/icons/tv.svg";
import { ReactComponent as Users } from "../../images/icons/users.svg";
import { ReactComponent as Clock } from "../../images/icons/clock.svg";
import { Equipment, Game } from '../types';
import { getParticipants } from '../utils/games';

interface Props {
    game: Game;
}

const GameOptionsIconList = ({ game }: Props) => {

    const isScreen = game.equipment.includes(Equipment.SCREEN); 
    
    return (
        <ul className="flex w-fit mb-[16px] mx-auto md:mb-[21px] md:mx-0 lg:mb-0">
            <li className="flex items-center mr-[10px]"><Users /><span className="ml-[7px]">{getParticipants(game.players)}</span></li>
            {isScreen && <li className="flex items-center"><Tv /><span className="ml-[7px]"><T path={`games.common.forScreen.yes`} /></span></li>}
            <li className="flex items-center ml-[10px]"><Clock /><span className="ml-[7px]"><T path={`games.common.duration.${game.duration}`} /></span></li>
        </ul>
    )
}

export default GameOptionsIconList;